// papers#index — your papers, plus the upload dropzone.
import { registerPage } from "../first"
import { mountPaperUploadApps } from "../paper_upload"
import { mountRowLinks } from "../row_links"

export const PapersIndexPage = {
  onDomReady(): void {
    mountRowLinks()
    mountPaperUploadApps()
  },
}

registerPage("PapersIndexPage", PapersIndexPage)
